module.exports = __webpack_public_path__ + "img/logo-white-new.86cbd187.png";